import React from 'react'
import TeamSection from 'views/LandingPage/Sections/TeamSection'

const TeamPage = () => {
    return (
        <>
            <TeamSection/>
        </>
    )
}

export default TeamPage
